(() => {
  const formatGBP = (pence) => {
    const gbp = (Number(pence || 0) / 100);
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(gbp);
  };

  const updateTotal = async () => {
    const el = document.querySelector('[data-hulkapps-cart-total]');
    if (!el) return;

    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) return;

    const cart = await res.json().catch(() => null);
    if (!cart) return;

    // Keep the " GBP" suffix like your theme currently shows
    el.textContent = `${formatGBP(cart.total_price)} GBP`;
  };

  // Run once on load
  document.addEventListener('DOMContentLoaded', updateTotal);

  // Hook fetch() calls that change the cart
  const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
    const res = await origFetch.apply(this, args);

    if (
      res?.ok &&
      (url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear'))
    ) {
      // slight delay so Shopify finishes updating
      setTimeout(updateTotal, 150);
    }

    return res;
  };

  // Hook XHR too (some apps use this)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__pfp_url = url;
    return origOpen.call(this, method, url, ...rest);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      const url = this.__pfp_url || '';
      if (
        this.status >= 200 &&
        this.status < 300 &&
        (url.includes('/cart/add') ||
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear'))
      ) {
        setTimeout(updateTotal, 150);
      }
    });
    return origSend.apply(this, args);
  };
})();
